export default __webpack_public_path__ + "static/media/shipment.86abc50f.svg";